<template>
  <article
    class="event-popular-services"
    :class="{ 'event-popular-services--full-width': fullWidth }"
  >
    <h3 class="event-popular-services__header">
      <span>{{ $t("services.popularServices.title") }}</span>
      <icon name="star" class="event-popular-services__header-icon" />
      <a
        v-if="isOrderingAvailable"
        @click.prevent="
          $router.push({ name: 'popular-services', params: { id: eventId } })
        "
        class="event-popular-services__show-all"
        href="#"
      >
        {{ $t("services.popularServices.showAll") }}
      </a>
    </h3>
    <Notification
      v-if="!isOrderingAvailable"
      :warning="false"
      icon="warning-border--no-color"
      modify="_flex _documents"
    >
      <span
        class="event-popular-services__description"
        v-html="$t('services.popularServices.popularServiceEnd')"
      >
      </span>
    </Notification>
    <div class="event-popular-services__content" v-else>
      <EventPopularServicesList :list="popularServices" />
    </div>
  </article>
</template>

<script>
import EventPopularServicesList from "@/components/Custom/EventPopularServicesList.vue";
import { mapState } from "vuex";
import diffInSeconds from "@/helpers/diffInSeconds";
import { Notification } from "@v2/shared/ui/components";
import apiServices from "@/api/services";
export default {
  name: "EventPopularServices",
  components: { Notification, EventPopularServicesList },
  props: {
    fullWidth: Boolean,
    eventId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      popularServices: []
    };
  },
  methods: {
    diffInSeconds,
    async getPopularServices() {
      await apiServices
        .additionalServices(this.eventId, {
          is_popular: 1
        })
        .then(({ data }) => {
          this.popularServices = data;
        });
    }
  },
  computed: {
    ...mapState("event", ["event"]),
    isOrderingAvailable() {
      return this.event.exhibition.is_allowed_create_additional_order;
    }
  },
  mounted() {
    this.getPopularServices();
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.event-popular-services {
  width: 620px;
  background-color: var(--white, #fff);
  margin-top: 30px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;

  @media (max-width: 1000px) {
    width: 442px;
  }

  @media (max-width: 740px) {
    margin-top: 0;
  }

  &--full-width {
    width: 100%;
    border: 1px solid var(--gray-darker, #d5dae5);
  }

  &__header {
    @include h2();
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 20px 30px;
    gap: 5px;

    border-bottom: 1px solid #f1f1f1;

    position: relative;

    @media (max-width: 740px) {
      padding: 20px;
    }

    @media (max-width: 485px) {
      flex-direction: column;
      align-items: flex-start;
    }

    > span {
      margin-right: 30px;
    }

    &-icon {
      position: absolute;
      right: 15px;
      top: 50%;
      opacity: 0.05;
      pointer-events: none;

      transform: translateY(-50%);

      width: 80px;
      height: 80px;

      @media (max-width: 740px) {
        width: 56px;
        height: 56px;
      }
    }
  }

  &__show-all {
    border-bottom: 1px solid #a3a8b3;
    text-decoration: none;

    font-size: 12px;
    font-weight: 400;
    line-height: 1.5;
    color: #6d7179;

    &:hover {
      color: #005197;
    }
  }

  &__content {
    position: relative;
    padding: 30px;
    height: 100%;

    @media (max-width: 740px) {
      padding: 20px;
    }

    &:after {
      content: "";
      position: absolute;
      right: 0;
      bottom: 0;
      display: block;
      width: 50px;
      height: 230px;
      pointer-events: none;
      background: linear-gradient(
        270deg,
        #ffffff 13.02%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }

  &__description {
    display: block;
    font-size: 14px;
    line-height: 1.57;
    color: #6d7179;
    & a {
      color: inherit;
    }
  }
}
</style>
